import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API } from '../config/api';

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page visit when component mounts or location changes
    const trackVisit = async () => {
      try {
        await fetch(`${API}/api/analytics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: location.pathname,
            timestamp: new Date().toISOString(),
            url: window.location.href
          })
        });
      } catch (error) {
        // Silently fail - analytics shouldn't break the user experience
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Track the visit after a small delay to ensure page is loaded
    const timeoutId = setTimeout(trackVisit, 100);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default VisitorTracker;
